import { useState, useCallback, useEffect } from "react";
import { useConfig } from "./useConfig";
import { PrizeDto } from "../models/Lottery";
import { useSnackbar } from "notistack";

export const useDrawnPrizes = (sessionId: string) => {
  const [lotteryPrizes, setLotteryPrizes] = useState<PrizeDto[]>([]);
  const [loading, setLoading] = useState(false);
  const { config } = useConfig();
  const { enqueueSnackbar } = useSnackbar();

  const fetchData = useCallback(async () => {
    if (!sessionId) return;
    setLoading(true);
    try {
      const res = await fetch(`${config.apiUrl}/lottery/prize/${sessionId}/drawn`, {
        method: "GET",
      });

      if (!res.ok) throw new Error(`Request failed with status ${res.status}`);

      const json = (await res.json()) as any;
      setLotteryPrizes(json);
    } catch (err) {
      console.log(err);
      enqueueSnackbar(`${err}`, {
        variant: "error",
        autoHideDuration: 4000,
      });
    } finally {
      setLoading(false);
    }
  }, [config.apiUrl, enqueueSnackbar, sessionId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { lotteryPrizes, loading, refetch: fetchData };
};
